import React, { useState } from "react";

export default function PopupSensorTable() {
    const [editing, setEditing] = useState(false);

    const handleButtonClick = () => setEditing(false);

    return (<></>
        // <div className="flex justify-around items-center gap-1">
        //     {!editing ? (
        //         <button onClick={() => setEditing(true)}>Edit layout</button>
        //     ) : (
        //         <>
        //             <button onClick={handleButtonClick}>add tab</button>
        //             <button onClick={handleButtonClick}>add widget</button>
        //             <button onClick={handleButtonClick}>load config</button>
        //             <button onClick={handleButtonClick}>reset config to default</button>
        //             <button onClick={handleButtonClick}>save & close</button>
        //             <button onClick={handleButtonClick}>cancel</button>
        //         </>
        //     )}
        // </div>
    );
}